import { Button, Col, Row } from 'antd';
import React from 'react';
import { Trans } from 'react-i18next';

import FilterItem from './FilterItem';
import FilterPopover from './FilterPopover';
import FilterSection from './FilterSection';
import styles from './FilterToolbar.module.css';

interface FilterToolbarProps {
  onClear?: () => void;
  clearButtonSize?: 'large' | 'middle' | 'small';
  tagsBelow?: boolean;
  children: React.ReactNode[];
}

const FilterToolbar = ({
  onClear,
  clearButtonSize = 'small',
  tagsBelow = false,
  children,
}: FilterToolbarProps) => {
  //Works only for Sections with multiple FilterItem
  const selectedFromSections = React.Children.map(children, (child) => {
    if (React.isValidElement(child) && child.type === FilterSection) {
      //Scan for FilterItem children and return them
      return child.props?.children
        ?.filter(
          (c: React.ReactNode) =>
            React.isValidElement(c) && c.type === FilterItem && c.props.selected
        )
        .map((c: React.ReactElement) => c.props.selected);
    }

    return null;
  });

  const selected = React.Children.map(children, (child) => {
    if (React.isValidElement(child) && child.type === FilterItem && child.props.selected) {
      return child.props.selected;
    }

    return null;
  });
  const selecteds = [...(selected || []), ...(selectedFromSections || [])];

  const clearButton = onClear && (
    <Button data-testid="toolbar-clear-filters" size={clearButtonSize} onClick={() => onClear()}>
      <Trans>Limpar filtros</Trans>
    </Button>
  );

  return (
    <>
      <Row className={styles.row} gutter={[8, 16]} align="bottom">
        {React.Children.map(children, (child) => {
          if (React.isValidElement(child) && child.type === FilterItem) {
            const { alwaysOn = false, flex, span, ...props } = child.props;

            if (alwaysOn) {
              return (
                <Col flex={flex} span={span}>
                  <FilterPopover {...props} />
                </Col>
              );
            }

            return null;
          }

          return child;
        })}
        {!tagsBelow && selecteds && selecteds.length > 0 && (
          <Col span={24} data-testid="toolbar-tags-container">
            {selecteds}
            {clearButton}
          </Col>
        )}
        {tagsBelow && clearButton && <Col>{clearButton}</Col>}
      </Row>
      {tagsBelow && selecteds && selecteds.length > 0 && (
        <Row gutter={[8, 8]} className={styles.row}>
          <Col data-testid="toolbar-tags-container">{selecteds}</Col>
        </Row>
      )}
    </>
  );
};

export default FilterToolbar;
